export const color = {
  // Color systems
  black: '#0f172a',
  white: '#FFFFFF',
  white_500: '#FFFFFF',
  white_600: '#f8fafc',
  white_650: '#f1f5f9',
  white_700: '#e2e8f0',
  white_800: '#cbd5e1',
  gray_400: '#94a3b8',
  gray_500: '#64748b',
  gray_600: '#475569',
  gray_700: '#1e293b',
  cerulean_blue_500: '#2563eb',
  // Primary colors
  PLColor1: '#1e293b',
  PLColor2: '#3b82f6',
  PLGradient: ['#0f172a', '#1e293b'],
  PLPurple: '#6366f1',
  PLYellow: '#f59e0b',
  default: '#475569',
  success: '#10b981',
  error: '#ef4444',
  info: '#3b82f6',
  warning: '#f59e0b',
  // Logic colors
  red: '#ef4444',
  green: '#10b981',
  blue: '#3b82f6',
  orange: '#f59e0b',
  // Other colors
  veryLightGray: '#e2e8f0',
  solitude: '#f1f5f9',
  ghostWhite: '#f8fafc',
  suvaGrey: '#94a3b8',
  slateBlue: '#6366f1',
  darkPurple: '#7c3aed',
  dark: '#0f172a',
  billCircle: '#f1f5f9',
  primaryGradient: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
  sky: '#3b82f6',
  profileBackground: '#cbd5e1',
  fanzColorLight: '#f1f5f9',
  fanzColorLight2: '#f0f9ff',
};
